/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   buildImageUrl
 */

import { constructUrl } from '../../../shared/packages/imgix'

const defaultOptions = {
  fit: 'clip',
}

/**
 * constructs appropriate image url
 *
 * @param {object} options object args
 * @param {string=} options.fallbackUrl optional fallback url
 * @param {string=} options.fit desired fit
 * @param {number} options.h height
 * @param {number=} options.dpr optional device pixel ratio
 * @param {string=} options.url url of image
 * @param {number} options.w width
 * @returns {string} image url
 */
export const buildImageUrl = ({ fallbackUrl, url, ...options }) => {
  const cdnUrl = url || fallbackUrl
  if (!cdnUrl) {
    return ''
  }

  const isSVG = /\.svg$/i.test(cdnUrl)
  if (isSVG) {
    return cdnUrl
  }

  return constructUrl(cdnUrl, { ...defaultOptions, ...options })
}
